import { Stat } from '../../api';
import MonthPieChart from './MonthPieChart';

function getDomains(data: Stat): Record<string, Array<number>> {
  return data?.fastForward?.hls?.speeds ? data.fastForward.hls.speeds : {};
}

function getTitle(): string {
  return 'Fast Forward HLS bandwidth usage by speed';
}

export default function MonthCameraFastForwardHlsSpeedsChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
}) {
  return <MonthPieChart getTitle={getTitle} getDomains={getDomains} {...props} />;
}
